export enum AcademicTier {
    School = 'SCHOOL',
    University = 'UNIVERSITY',
}
